/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint max-lines: ["error", 600]*/
/* eslint-disable no-lonely-if */
import countriesOptions from '@/mixins/countriesOptions';
import DatePickerMixin from '@/mixins/datepicker';
import DraftData from '@/components/draft-data';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import maritalStatusOptions from '@/mixins/maritalStatusOptions';
import matrimonialRegimeOptions from '@/mixins/matrimonialRegimeOptions';
import Validations from '@/mixins/validations';

export default {
    name: 'PersonalData',

    components: {
        DraftData
    },

    mixins: [
        Validations,
        DatePickerMixin,
        formatData,
        keyed,
        countriesOptions,
        maritalStatusOptions,
        matrimonialRegimeOptions
    ],

    /**
     * @override
     */
    data() {
        return {
            vissibilityCollapse1: true,
            detailsEdit: false,
            sexOptions: ['V', 'H'],
            documentTypesOptionsPF: [
                'DNI',
                'CIF',
                'PASAPORTE',
                'CEDULA_IDENTIFICACION',
                'TARJETA_RESIDENTE',
                'JURIDICA_EXTRANGERA',
                'OTROS'
            ],
            documentTypesOptionsPJ: ['CIF'],
            classOptions: ['A', 'B', 'C', 'D'],
            duplicateDNI: false,
            formatDataRules: () => ({
                key_nationality_1: [value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)],
                key_nationality_2: [value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)],
                key_country_of_birth: [value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)],
                marital_status: [value => (value ? { key: value, name: this.$t(`maritalStatus.${value}`) } : null)],
                matrimonial_regime: [value => (value ? { key: value, name: this.$t(`matrimonialRegime.${value}`) } : null)]
            }),
            datepickerBirthdate: '',
            datepickerDocument: '',
            datepickerDeathdate: '',
            expiredDocumentDate: false,
            investorClassOptions: ['MINORISTA', 'NO_PROFESIONAL', 'PROFESIONAL'],

        };
    },
    watch: {
        datepickerBirthdate(val) {
            this.setValueEdited('birthdate', val);
        },
        datepickerDocument(val) {
            this.setValueEdited('document_expiration_date', val);
        },
        datepickerDeathdate(val) {
            this.setValueEdited('deathdate', val);
        }

    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        data: {
            type: Object,
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        disableLegalIntervenerOption: {
            type: Boolean,
            required: false,
            default: false
        },
        physicalIntervenersMustBeAdults: {
            type: Boolean,
            required: false,
            default: false
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        editDetails(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.detailsEdit = edit;
            if (edit) {
                if (!this.vissibilityCollapse1) {
                    this.$root.$emit('bv::toggle::collapse', 'collapse-1');
                }
            }
            if (!edit) {
                this.formatData();
                this.modifiedData = {};
            }
        },
        /**
         * Validate personal data (Promise)
         * @param {Object} personalData to validate
         * @return {Boolean} valid or not
         */
        validateData() {
            this.cleanErrors();

            let requiredProperties = ['document_id'];
    
            return Promise.resolve(true)
                .then(valid => this.validateRequired(requiredProperties, valid))
        },

        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            const dataContainer = 'modifiedData';

            switch (field) {
                case 'intervener_type':
                    this[dataContainer].document_type = null;
                    this[dataContainer].intervener_type = val;
                    break;
                case 'brand_name':
                    this[dataContainer]['lastname_1'] = val;
                    break;
                case 'document_id':
                case 'document_type':
                    this[dataContainer][field] = typeof val === 'object' ? val.key : val;
                    break;
                case 'birthdate':
                case 'document_expiration_date':
                case 'deathdate':
                    if (this.formattedData[field] !== val && (val || val === null)) {
                        this[dataContainer][field] = val;
                        this.$set(this.formattedData, field, val);
                    }
                    break;
                case 'is_document_permanent':
                    if (val) {
                        this[dataContainer].document_expiration_date = null;
                        this.formattedData.document_expiration_date = null;
                    }
                    this[dataContainer][field] = val;
                    this.formattedData[field] = val;
                    break;
                default:
                    this[dataContainer][field] = typeof val === 'object' ? val.key : val;
                    break;
            }

            this.$emit(`${field}-changed`, val);
        },

        /**
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            e.preventDefault();
            this.fetchValidatedData().then(vd => {
                if (!vd) {
                    this.$toast.error('Error en datos de personales', 'Revisa los campos marcados en rojo');
                    return;
                }
                if (!this.modifiedData['deathdate']) {
                    this.modifiedData['deathdate'] = undefined;
                }

                this.$intervenersService
                    .updateIntervenerInfo(this.uuid, this.modifiedData )
                    .then(res => {
                        this.$toast.success(res.result.http_code, res.result.info);
                        this.detailsEdit = false;
                        this.$root.$emit('refresh_intervener');
                    })
                    .catch(err => {
                        this.$toast.error(err.name, err.message);
                        this.formatData();
                        this.detailsEdit = false;
                    });
            });
        }
    },
    /**
     * @override
     */
    beforeMount() {
        if (this.creation) {
            this.detailsEdit = !this.existing;
        }

        this.formatData();
        this.expiredDocumentDate = new Date(this.formattedData.document_expiration_date) <= new Date() ? true : false;
        this.loadMaritalStatusOptions();
        this.loadMatrimonialRegimeOptions();
    },

    computed: {
        intervenerTypeOptions() {
            if (this.disableLegalIntervenerOption) {
                return ['F'];
            }
            return ['F', 'J'];
        },
        /**
         * Devuelve los tipos de documentación según el tipo de interviniente
         * @return {Array} Devuelve los tipos de documentación según el tipo de interviniente
         */
        documentTypesOptions() {
            if (this.formattedData.intervener_type === 'J') {
                return this.documentTypesOptionsPJ;
            } else {
                if (
                    this.creation &&
                    this.formattedData.key_country_of_birth &&
                    this.formattedData.key_country_of_birth.key === 'ESP' &&
                    (this.formattedData.key_nationality_1 && this.formattedData.key_nationality_1.key === 'ESP')
                ) {
                    if (this.formattedData.document_type !== 'DNI') {
                        this.$toast.error('Rellene el DNI', 'Debe rellenar obligatoriamente su DNI');
                        this.formattedData.document_id = '';
                    }
                    this.formattedData.document_type = 'DNI';
                    return ['DNI'];
                } else {
                    return this.documentTypesOptionsPF;
                }
            }
        },
        mustBeAdult() {
            return (
                this.isContributor
                || (this.formattedData.intervener_type === 'F' && this.physicalIntervenersMustBeAdults)
                || (!this.formattedData.intervener_type  && this.physicalIntervenersMustBeAdults)
            );
        }
    }
};
